import React, { useEffect } from 'react';

const ScrollZoomControlOverlay = ({ setScrollZoomControlOverlayVisible }) => {
  
  useEffect(() => {
    setScrollZoomControlOverlayVisible && setTimeout(() => {
      setScrollZoomControlOverlayVisible(false);
    }, 1250)

    return () => {}
  }, [setScrollZoomControlOverlayVisible]);

  return (
    <div style={{
      position: 'absolute', 
      top: 100, left: 100,
      // top: '50%', 
      // left: '50%', 
      // transform: 'translateX(-50%) translateY(-50%)', 
      transition: 'opacity 1s ease-in-out', 
      width: 200, 
      height: 200, 
      display: 'flex', 
      padding: 20,
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center', 
      backgroundColor: 'rgba(0, 0, 0, 0.25)', 
      zIndex: 999,
      boxShadow: '2px 2px 2px lightgrey',
      borderRadius: 10
    }}>
      <span style={{marginTop: 0, fontSize: 18, fontWeight: 'bold', color: '#fff', textShadow: '2px 2px 2px grey'}}>To zoom the map </span>
      <div style={{width: '100%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', opacity: 0.75, marginTop: 20}}>
        <AltKeyIcon />
        <PlusIcon />
        <ScrollIcon />
      </div>
    </div>
  )
}

const AltKeyIcon = () => {
  return (
    <div style={{height: 50, width: 50, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 6, border: '2px solid grey', backgroundColor: '#fff'}}>
      <span style={{fontSize: '20px'}}>Alt</span>
    </div>
  )
}

const PlusIcon = () => {
  return (
    <span style={{fontSize: '50px', color: '#fff', textShadow: '2px 2px 0 grey, -2px -2px 0 grey, 2px -2px 0 grey, -2px 2px 0 grey, 2px 0 0 grey, 0 2px 0 grey, -2px 0 0 grey, 0 -2px 0 grey'}}>+</span>
  )
}

const ScrollIcon = () => {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: '35px', // Adjust the size as needed
      height: '50px', // Adjust the size as needed
      border: '2px solid grey', // Change border color and width as needed
      borderRadius: '15px', // Adjust border radius as needed
      position: 'relative',
      backgroundColor: '#fff',
    },
    wheel: {
      width: '6px',
      height: '12px',
      backgroundColor: 'grey',
      marginTop: 5
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.wheel}>
      </div>
    </div>
  );
};

export default ScrollZoomControlOverlay;